<!-- Young -->
<template>
  <div class='public-bread-crumb'>
    <span class="bread-first">运维系统</span>
    <div v-for="(i, index) in routes" :key="index">
      <i style="margin: 0 8px;">/</i>
      <router-link :to="i.path" class="router-link" v-if="index < routes.length - 1">{{i.name}}</router-link>
      <span class="router-link" v-else>{{i.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicBreadCrumb',
  props: ['routes'],
  data () {
    return {}
  },
  computed: {
    // 监听属性 类似于data概念
  },
  watch: {
    // 监控data中的数据变化
  },
  methods: {},
  created () {
    // 生命周期-创建完成(可以访问当前this实例)
  },
  mounted () {
    // 生命周期-挂载完成(可以访问DOM元素)
  }
}
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .public-bread-crumb {
    height: 69px;
    background: #F8F8FA;
    padding: 24px;
    display: flex;
    font-size: 16px;
    .bread-first {
      color: #5862CB;
    }
    .router-link {
      color: #808080;
    }
  }
</style>
